module.exports = __webpack_public_path__ + "img/cooperate_qy_01@2x.6a9e2ef7.png";